import React from 'react'
import styled from 'styled-components'

import { Color } from '../../theme/color'

type Props = {
  isShort?: boolean
}

export const DivideLineBold: React.FC<Props> = ({ isShort }) => {
  return <StyleDivideLineBold short={isShort} />
}
const StyleDivideLineBold = styled.div<{ short?: boolean }>`
  border-bottom: solid 6px ${Color.line};
  margin: ${(props) => (!props.short ? null : '0 20px')};
`
